import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AbbDashboardRoutingModule } from './abb-dashboard-routing.module';
import { AbbDashboardComponent } from './abb-dashboard.component';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '../../core/core.module';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/primeng';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TableModule } from 'primeng/table';
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
  imports: [
    AbbDashboardRoutingModule,
    CalendarModule,
    CommonModule,
    CoreModule,
    FormsModule,
    NgbModule,
    TableModule,
    TranslateModule,
    NgSelectModule,
  ],
  declarations: [AbbDashboardComponent]
})
export class AbbDashboardModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard.module.ts